<template>
  <div>
    <template v-if="dirty">
      <div class="text-center text-xl text-text font-medium">{{ $t('loading') }}</div>
    </template>
    <template v-else-if="!Object.keys(transactions).length">
      <div class="text-center text-xl text-text font-medium">{{ $t('noItemsText') }}</div>
    </template>
    <template v-else>
      <template v-if="sortBy === 'date' || sortBy === 'created_at'">
        <div v-for="(transactionDate,date,i) in transactionsByDate" :key="i">
          <TransactionDate :date="date" :transactions="transactionDate" class="md:-mx-6"/>
          <TransactionItem v-for="(transaction,j) in transactionDate" :key="j"
                           :transaction="transaction"
                           :layout="sortBy === 'date' ? 'default' : 'full-date'"
                           :currency-display="currencyDisplay"
                           @edit="$emit('edit',$event)"
                           @remove="$emit('remove',$event)"/>
        </div>
      </template>
      <template v-else-if="sortBy === 'sum_base'">
        <TransactionItem v-for="(transaction,j) in transactionsSortedBySumBase" :key="j"
                         :transaction="transaction"
                         :layout="'full-date'"
                         :currency-display="currencyDisplay"
                         @edit="$emit('edit',$event)"
                         @remove="$emit('remove',$event)"/>
      </template>
    </template>

  </div>
</template>

<script>
import {mapActions} from "vuex";
import TransactionDate from "@/components/common/Transaction/TransactionDate";
import TransactionItem from "@/components/common/Transaction/TransactionItem/TransactionItem";
import transactionCurrencyDisplayProp from "@/mixins/transactionCurrencyDisplayProp";

export default {
  name: "TransactionList",
  components: {
    TransactionItem,
    TransactionDate
  },
  mixins: [transactionCurrencyDisplayProp],
  props: {
    transactionsByDate: {
      type: Object,
      required: true
    },
    transactions: {
      type: Array,
      required: true
    },
    dirty: {
      type: Boolean,
      default: true
    },
    sortBy: {
      default: 'date',
      validator: (val) => ['date', 'created_at', 'sum_base'].includes(val)
    },
    sortType: {
      default: '',
      validator: (val) => ['', '-'].includes(val)
    }
  },
  computed: {
    transactionsSortedBySumBase() {
      //map transactions sum_base with minus if expense and index
      let mapped = [...this.transactions].map((item, i) => {
        return {
          index: i,
          ...item,
          sum_base: item.type === 2
              ? -item.sum
              : item.sum
        }
      });
      mapped.sort((a, b) => (
          this.sortType === '-' ? b.sum_base - a.sum_base : a.sum_base - b.sum_base
      ))

      return mapped.map((el) => this.transactions[el.index]);
    }
  },
  data() {
    return {
      edit_transaction: null,
      edit_transfer: null,

      saving_transaction: false,
      saving_transfer: false,

      confirm_delete: false
    }
  },
  methods: {
    ...mapActions('space/transactions', ['updateTransaction', 'removeTransaction']),
    ...mapActions('space/transfers', ['updateTransfer', 'removeTransfer']),
  },
  i18n: {
    messages: {
      en: {
        loading: 'Loading...',
        noItemsText: 'Nothing found, please try changing filters'
      },
      ru: {
        loading: 'Загрузка...',
        noItemsText: 'Ничего не найдено, попробуйте изменить фильтры'
      },
    }
  }
}
</script>

<style lang="scss">
.transactions__list {
  border: 1px solid #D3D7DC;
  border-radius: 3px;
  color: #555;
  width: 100%;
  font-size: 12px;
  transition: all .2s;
  border-spacing: 0;
  overflow: hidden;
  border-collapse: unset;

  thead.header {
    background: #F3F5F7;
    font-weight: bold;

    th {
      padding: 0 11px;
      text-align: left;
      height: 40px;
      border-bottom: 1px solid #D3D7DC;

      &:nth-of-type(1) {
        padding: 0;
        width: 5px;
      }

      &:nth-of-type(2) {
        width: 10.3%;
        text-align: center;
      }

      &:nth-of-type(5) {
        width: 40%;
      }

      &:nth-of-type(6) {
        text-align: right;
      }

      &:nth-of-type(7) {
        width: 10px;
        padding: 0;
      }
    }
  }

  .item {
    position: relative;
    min-height: 40px;

    &.--loading {
      span {
        width: 100%;
        height: 20px;
      }

    }

    .indicator {
      padding: 1px;

      > span {
        display: block;
        width: 3px;
        height: 32px;
        border-radius: 1px;
        background: transparent;
      }
    }

    &.income .indicator span {
      background: #709F94;
    }

    &.expense .indicator span {
      background: #F2526F;
    }

    &.transfer {
      .indicator span {
        background: #E6941A;
      }

      .value {
        color: #E6941A;
      }
    }

    &:last-of-type {
      td {
        border-bottom: 0;
      }
    }

    td {
      border-bottom: 1px solid #D3D7DC;
      padding: 10px 11px;
      text-align: left;

      &:nth-of-type(2) {
        white-space: nowrap;
        text-align: center;
      }
    }

    .value {
      text-align: right;
      color: #709F94;
      white-space: nowrap;

      &.negative {
        color: #F2526F;
      }

      .comission {
        background: #82868B;
        width: 10px;
        height: 10px;
        margin-right: 8px;
        color: #F3F5F7;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border-radius: 2px;

        svg {
          width: 6px;
          height: 6px;
        }
      }
    }

    .time {
      color: #B1B7BD;
    }

    .comment {
      color: #82868B;
    }

    .icon {
      padding-left: 12px;
      padding-right: 16px;
      position: relative;

      button {
        padding: 0;
        background: none;
        border: 0;
        color: #555;
        transition: all .2s;
        cursor: pointer;
      }

      svg {
        width: 14px;
      }

      &:hover {
        button {
          color: #486680;
        }
      }


    }
  }

  .not-found {
    padding: 16px 0;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
  }
}

.transactions__popover.tooltip.popover {
  .popover-inner {

    padding: 6px 0 4px;
    border: 1px solid #D3D7DC;

    .transactions__popover__btn {
      display: block;
      text-align: left;
      line-height: 24px;
      font-size: 11px;
      color: #555;
      min-width: 40px;
      width: 100%;
      padding-left: 8px;
      padding-right: 10px;
      background: transparent;
      border: 0;
      cursor: pointer;
      transition: all .2s;

      svg {
        width: 10px;
        margin-right: 8px;
      }

      &:hover {
        background: #F3F5F7;
        color: #486680;
      }

      &.--red {
        color: #F2526F;

        &:hover {
          background: rgba(242, 82, 111, .2);
        }
      }
    }
  }

  .popover-arrow {
    display: none;
  }
}
</style>
